const light = {
    bgColor: "#fff",
    textColor: "#000",
};
const dark = {
    bgColor: "#121212",
    textColor: "#ECECEC",
};

const theme = {
    light,
    dark,
};

export default theme;
